import { Action, OperationType } from "puzzle";

export const submissionStatusGetDeliverableFiles: Action = [{
  name: 'pingUntilDownloadIsReady',
  type: OperationType.action
}];
